// extracted by mini-css-extract-plugin
module.exports = {"root":"bGvZOY","tablist":"PmFUDD","fitContentTablist":"A7dHp6","cursor":"NMX3G7"};